const YOUTUBE_ID_PATTERNS = [
  /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s]+)/,
  /youtube\.com\/embed\/([^&\s]+)/,
];

export const extractVideoId = (url: string): string | null => {
  for (const pattern of YOUTUBE_ID_PATTERNS) {
    const match = url.match(pattern);
    if (match?.[1]) return match[1];
  }
  return null;
};

export const isYouTubeUrl = (url: string): boolean =>
  /youtube\.com|youtu\.be/.test(url);

export const getYouTubeThumbnailUrl = (videoUrl: string): string | null => {
  const id = extractVideoId(videoUrl);
  return id ? `https://img.youtube.com/vi/${id}/mqdefault.jpg` : null;
};

export const getYouTubeEmbedUrl = (
  videoUrl: string,
  autoplay = false
): string | null => {
  const id = extractVideoId(videoUrl);
  return id
    ? `https://www.youtube.com/embed/${id}?autoplay=${autoplay ? 1 : 0}`
    : null;
};
